import request from '@/utils/request'

export function pageOrderMasterBond(query) {
  return request({
    url: '/order/order-master-bond/page',
    method: 'get',
    params: query
  })
}

export function getOrderMasterBond(data) {
  return request({
    url: '/order/order-master-bond/detail',
    method: 'get',
    params: data
  })
}

export function addOrderMasterBond(data) {
  return request({
    url: '/order/order-master-bond/add',
    method: 'post',
    data: data
  })
}

export function updateOrderMasterBond(data) {
  return request({
    url: '/order/order-master-bond/edit',
    method: 'post',
    data: data
  })
}

export function delOrderMasterBond(data) {
  return request({
    url: '/order/order-master-bond/delete',
    method: 'post',
    data: data
  })
}
